// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"fa9586be","374":"10c97f75","432":"9695a1f8","453":"97c97924","466":"b207b9e8","507":"7d219916","696":"59c4946f","903":"c3d818ee","923":"918ed522"}[chunkId] + ".chunk.js";
};